(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-cart-drawer')) {
    class PmCartDrawer extends HTMLElement {
      constructor() {
        super();
        this.live = this.querySelector('[data-pm-live]');
        this.openTrigger = null;
        this.focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
        this._noteTimer = null;
        this._qtyTimers = new Map();
        this._lastSubtotal = null;
      }
      connectedCallback() {
        this._bindGlobalTriggers();
        this._bindEvents();
      }
      _bindGlobalTriggers() {
        const handler = (e) => {
          const trigger = e.target.closest(
            '[data-pm-cart-open],' +
            'a[href="/cart"],a[href$="/cart"],a[href*="/cart?"],' +
            '[aria-controls*="cart-drawer"],[aria-controls="CartDrawer"],' +
            '[data-cart-toggle],[data-action*="cart"],' +
            'cart-icon,cart-icon-bubble,#cart-icon-bubble,[data-testid="cart-icon"],' +
            '.header-actions__cart-icon,.header__cart,.header__icon--cart,.cart-link,' +
            '.header__icon--cart,a.header__icon--cart,#cart-icon-bubble,' +
            'header-drawer [aria-controls*="cart"],summary[aria-controls*="cart"]'
          );
          if (!trigger) return;
          if (trigger.hasAttribute('data-pm-cart-bypass')) return;
          if (this.contains(trigger)) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }
          this.openTrigger = trigger;
          this.refreshAndOpen();
        };
        document.addEventListener('click', handler, true);
        document.addEventListener('cart:added', () => this.refreshAndOpen({ animateNew: true }));
        document.addEventListener('cart:updated', () => this.refresh());
        document.addEventListener('cart-update', () => this.refresh());
        document.addEventListener('cart:refresh', () => this.refresh());
        if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          try {
            window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshAndOpen({ animateNew: true }));
          } catch (_) {}
        }
        this._suppressNativeDrawer();
      }
      _suppressNativeDrawer() {
        const closeIt = () => {
          document.querySelectorAll('cart-drawer.active, cart-drawer[open]').forEach(d => {
            d.classList.remove('active');
            d.removeAttribute('open');
            d.setAttribute('aria-hidden', 'true');
          });
          document.querySelectorAll('cart-drawer-component dialog[open], dialog.cart-drawer__dialog[open]').forEach(d => {
            try { d.close(); } catch (_) {}
            d.removeAttribute('open');
          });
        };
        closeIt();
        if (this._nativeObserver) return;
        this._nativeObserver = new MutationObserver(closeIt);
        const target = document.querySelector('cart-drawer') || document.querySelector('cart-drawer-component') || document.body;
        this._nativeObserver.observe(target, {
          attributes: true,
          attributeFilter: ['open', 'class', 'aria-hidden'],
          subtree: true
        });
      }
      _bindEvents() {
        this.addEventListener('click', (e) => {
          const closer = e.target.closest('[data-pm-close]');
          if (closer) this.close();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen()) this.close();
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pm-qty]');
          if (!btn) return;
          const key = btn.getAttribute('data-key');
          const direction = btn.getAttribute('data-pm-qty');
          const input = this.querySelector(`[data-pm-qty-input][data-key="${key}"]`);
          if (!input) return;
          let qty = parseInt(input.value, 10) || 1;
          qty = direction === 'increase' ? qty + 1 : Math.max(1, qty - 1);
          input.value = qty;
          this._bumpQty(input);
          this._scheduleQtyUpdate(key, qty);
        });
        this.addEventListener('input', (e) => {
          const input = e.target.closest('[data-pm-qty-input]');
          if (!input) return;
          const key = input.getAttribute('data-key');
          let qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 1) qty = 1;
          this._bumpQty(input);
          this._scheduleQtyUpdate(key, qty);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pm-remove]');
          if (!btn) return;
          const key = btn.getAttribute('data-key');
          this._removeItem(key);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pm-add]');
          if (!btn) return;
          const variantId = btn.getAttribute('data-pm-add');
          this._addUpsell(variantId, btn);
        });
        this.addEventListener('input', (e) => {
          const note = e.target.closest('[data-pm-note]');
          if (!note) return;
          clearTimeout(this._noteTimer);
          this._noteTimer = setTimeout(() => this._saveNote(note.value), 600);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pm-discount-apply]');
          if (!btn) return;
          this._handleDiscountApply(btn);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter') return;
          const input = e.target.closest('[data-pm-discount-input]');
          if (!input) return;
          e.preventDefault();
          const btn = this.querySelector('[data-pm-discount-apply]');
          if (btn) this._handleDiscountApply(btn);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Tab' || !this.isOpen()) return;
          const focusables = this._getFocusables();
          if (focusables.length === 0) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
      }
      _getFocusables() {
        const panel = this.querySelector('.pm-drawer__panel');
        if (!panel) return [];
        return Array.from(panel.querySelectorAll(this.focusableSelector))
          .filter(el => !el.hasAttribute('hidden') && el.offsetParent !== null);
      }
      isOpen() { return this.getAttribute('data-open') === 'true'; }
      open() {
        if (this.isOpen()) return;
        this.setAttribute('data-open', 'true');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          const panel = this.querySelector('.pm-drawer__panel');
          if (panel) panel.focus();
        }, 50);
        this._announce(this.dataset.i18nOpened || 'Cart drawer is open');
      }
      close() {
        if (!this.isOpen()) return;
        this.setAttribute('data-open', 'false');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.touchAction = '';
        document.body.classList.remove('overflow-hidden');
        if (this.openTrigger && typeof this.openTrigger.focus === 'function') {
          this.openTrigger.focus();
        }
        this.openTrigger = null;
      }
      _getCurrentItemKeys() {
        return Array.from(this.querySelectorAll('[data-pm-item]')).map(el => el.getAttribute('data-key'));
      }
      _getCurrentSubtotalText() {
        const el = this.querySelector('[data-pm-subtotal]');
        return el ? el.textContent.trim() : null;
      }
      async refresh(options = {}) {
        const { animateNew = false } = options;
        const oldKeys = animateNew ? this._getCurrentItemKeys() : [];
        const oldSubtotal = this._getCurrentSubtotalText();
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const url = `${root}?section_id=${this.dataset.sectionId}`;
          const res = await fetch(url);
          const text = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const newDrawer = doc.querySelector(`#${this.id}`);
          if (newDrawer) {
            const newPanel = newDrawer.querySelector('.pm-drawer__panel');
            const oldPanel = this.querySelector('.pm-drawer__panel');
            if (newPanel && oldPanel) {
              oldPanel.innerHTML = newPanel.innerHTML;
            }
          }
          if (animateNew) {
            const newKeys = this._getCurrentItemKeys();
            const addedKeys = newKeys.filter(k => !oldKeys.includes(k));
            addedKeys.forEach(k => {
              const item = this.querySelector(`[data-pm-item][data-key="${k}"]`);
              if (item) {
                item.classList.add('is-just-added');
                setTimeout(() => item.classList.remove('is-just-added'), 1200);
              }
            });
          }
          const newSubtotal = this._getCurrentSubtotalText();
          if (oldSubtotal && newSubtotal && oldSubtotal !== newSubtotal) {
            const sub = this.querySelector('[data-pm-subtotal]');
            if (sub) {
              sub.classList.add('is-bumping');
              setTimeout(() => sub.classList.remove('is-bumping'), 400);
            }
          }
        } catch (err) {
          console.error('[cart-drawer] refresh failed', err);
        }
      }
      async refreshAndOpen(options = {}) {
        await this.refresh(options);
        this.open();
      }
      _bumpQty(input) {
        if (!input) return;
        input.classList.remove('is-bumping');
        void input.offsetWidth;
        input.classList.add('is-bumping');
        setTimeout(() => input.classList.remove('is-bumping'), 400);
      }
      _scheduleQtyUpdate(key, qty) {
        if (this._qtyTimers.has(key)) clearTimeout(this._qtyTimers.get(key));
        this._qtyTimers.set(key, setTimeout(() => this._updateQty(key, qty), 350));
      }
      async _updateQty(key, quantity) {
        this._setLoading(true);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity })
          });
          if (!res.ok) throw new Error('Quantity update failed');
          await this.refresh();
          this._announce(this.dataset.i18nQtyUpdated || 'Quantity updated');
          this._dispatchUpdate();
        } catch (err) {
          console.error('[cart-drawer] qty update', err);
          this._announce(this.dataset.i18nErrorGeneric || 'An error occurred');
        } finally {
          this._setLoading(false);
        }
      }
      async _removeItem(key) {
        const item = this.querySelector(`[data-pm-item][data-key="${key}"]`);
        if (item) item.classList.add('is-removing');
        this._setLoading(true);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          if (!res.ok) throw new Error('Remove failed');
          await this.refresh();
          this._announce(this.dataset.i18nItemRemoved || 'Item removed from cart');
          this._dispatchUpdate();
        } catch (err) {
          console.error('[cart-drawer] remove', err);
          if (item) item.classList.remove('is-removing');
          this._announce(this.dataset.i18nErrorRemove || 'Error removing item');
        } finally {
          this._setLoading(false);
        }
      }
      async _addUpsell(variantId, btn) {
        if (btn) btn.setAttribute('data-loading', 'true');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('Add failed');
          await this.refresh({ animateNew: true });
          this._announce(this.dataset.i18nItemAdded || 'Item added');
          this._dispatchUpdate();
        } catch (err) {
          console.error('[cart-drawer] add upsell', err);
          this._announce(this.dataset.i18nErrorGeneric || 'An error occurred');
        } finally {
          if (btn) btn.removeAttribute('data-loading');
        }
      }
      async _saveNote(note) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note })
          });
          this._announce(this.dataset.i18nNoteSaved || 'Note saved');
        } catch (err) {
          console.error('[cart-drawer] note save', err);
        }
      }
      async _handleDiscountApply(btn) {
        const input = this.querySelector('[data-pm-discount-input]');
        const msgEl = this.querySelector('[data-pm-discount-msg]');
        if (!input) return;
        const code = input.value.trim();
        if (!code) {
          if (msgEl) {
            msgEl.textContent = this.dataset.i18nDiscountEmpty || 'Enter a code.';
            msgEl.setAttribute('data-state', 'error');
          }
          return;
        }
        btn.setAttribute('data-loading', 'true');
        if (msgEl) {
          msgEl.textContent = '';
          msgEl.removeAttribute('data-state');
        }
        try {
          await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET', redirect: 'manual' });
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const codes = (cart.discount_codes || []).filter(d => d.applicable);
          const matched = codes.some(d => (d.code || '').toUpperCase() === code.toUpperCase());
          if (matched) {
            if (msgEl) {
              const tpl = this.dataset.i18nDiscountAppliedTemplate || 'Code __CODE__ applied.';
              msgEl.textContent = tpl.replace('__CODE__', code.toUpperCase());
              msgEl.setAttribute('data-state', 'success');
            }
            input.value = '';
            await this.refresh();
            this._announce(this.dataset.i18nDiscountAppliedAnnounce || 'Promo code applied');
            this._dispatchUpdate();
          } else {
            if (msgEl) {
              msgEl.textContent = this.dataset.i18nDiscountError || 'Invalid promo code or cannot be applied to this order.';
              msgEl.setAttribute('data-state', 'error');
            }
            this._announce(this.dataset.i18nDiscountInvalid || 'Invalid promo code');
          }
        } catch (err) {
          console.error('[cart-drawer] discount', err);
          if (msgEl) {
            msgEl.textContent = this.dataset.i18nErrorRetry || 'An error occurred. Try again.';
            msgEl.setAttribute('data-state', 'error');
          }
        } finally {
          btn.removeAttribute('data-loading');
        }
      }
      _setLoading(state) {
        if (state) this.classList.add('is-loading');
        else this.classList.remove('is-loading');
      }
      _announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => { this.live.textContent = msg; }, 50);
      }
      _dispatchUpdate() {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    }
    customElements.define('pm-cart-drawer', PmCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId;
        this.productHandle = this.dataset.productHandle;
        this.triggerSelector = this.dataset.triggerSelector || '[data-pm-sticky-trigger]';
        this.moneyFormat = this.dataset.moneyFormat || ('$' + '{' + '{amount}' + '}');
        this.form = this.querySelector('[data-pm-sticky-form]');
        this.btn = this.querySelector('[data-pm-sticky-btn]');
        this.idInput = this.querySelector('[data-pm-sticky-id]');
        this.priceEl = this.querySelector('[data-pm-sticky-price]');
        this.variantEl = this.querySelector('[data-pm-sticky-variant]');
        this.imageEl = this.querySelector('[data-pm-sticky-image]');
        this.live = this.querySelector('[data-pm-sticky-live]');
        this._observer = null;
        this._productData = null;
        this._dawnUnsub = [];
      }
      connectedCallback() {
        this._setupObserver();
        this._bindVariantSync();
        this._bindDawnPubSub();
        this._bindSubmit();
        this._bindSoldOut();
        // Recompute after load + a short delay to catch browser scroll
        // restoration on refresh, which fires AFTER initial parse.
        const recheck = () => this._recomputeFromScroll();
        if (document.readyState === 'complete') {
          requestAnimationFrame(recheck);
        } else {
          window.addEventListener('load', () => requestAnimationFrame(recheck), { once: true });
        }
        setTimeout(recheck, 150);
      }
      disconnectedCallback() {
        if (this._observer) this._observer.disconnect();
        this._dawnUnsub.forEach(fn => { try { fn(); } catch (_) {} });
      }
      _recomputeFromScroll() {
        if (!this._triggerStates || this._triggerStates.size === 0) return;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        this._triggerStates.forEach((state, target) => {
          if (!target || !target.isConnected) return;
          const rect = target.getBoundingClientRect();
          state.visible = rect.top < vh && rect.bottom > 0;
          state.above = rect.bottom <= 0;
        });
        this._updateVisibility();
      }
      _setupObserver() {
        const triggers = document.querySelectorAll(this.triggerSelector);
        let targets;
        if (!triggers.length) {
          const fallback = document.querySelector('product-form, .product-form, [name="add"], button[type="submit"][name="add"], .product-form__submit, .product-form__buttons');
          if (fallback) {
            targets = [fallback];
          } else {
            this._scrollFallback();
            return;
          }
        } else {
          targets = Array.from(triggers);
        }
        if (!this._triggerStates) this._triggerStates = new Map();
        // Sync initial state — avoids the flash where IntersectionObserver
        // hasn't fired yet on first paint (esp. on refresh w/ restored scroll).
        const vh = window.innerHeight || document.documentElement.clientHeight;
        targets.forEach(t => {
          const rect = t.getBoundingClientRect();
          this._triggerStates.set(t, {
            visible: rect.top < vh && rect.bottom > 0,
            above: rect.bottom <= 0
          });
        });
        this._updateVisibility();
        targets.forEach(t => this._observe(t));
      }
      _observe(element) {
        if (!('IntersectionObserver' in window)) {
          this._scrollFallback(element);
          return;
        }
        if (!this._triggerStates) this._triggerStates = new Map();
        if (!this._observer) {
          this._observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const rect = entry.boundingClientRect;
              this._triggerStates.set(entry.target, {
                visible: entry.isIntersecting,
                above: !entry.isIntersecting && rect.bottom <= 0
              });
            });
            this._updateVisibility();
          }, {
            rootMargin: '0px',
            threshold: 0
          });
        }
        this._observer.observe(element);
      }
      _updateVisibility() {
        if (!this._triggerStates) return;
        const states = Array.from(this._triggerStates.values());
        const anyVisible = states.some(s => s.visible);
        const anyAbove = states.some(s => s.above);
        this._setVisible(!anyVisible && anyAbove);
      }
      _scrollFallback(triggerEl) {
        let visible = false;
        const compute = () => {
          if (triggerEl) {
            const rect = triggerEl.getBoundingClientRect();
            return rect.bottom < 0;
          }
          return window.scrollY > 600;
        };
        const onScroll = () => {
          const shouldShow = compute();
          if (shouldShow !== visible) {
            visible = shouldShow;
            this._setVisible(shouldShow);
          }
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      _setVisible(visible) {
        this.dataset.visible = visible ? 'true' : 'false';
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      _bindVariantSync() {
        document.addEventListener('change', (e) => {
          const target = e.target;
          if (!target || target === this.idInput) return;
          if (target.matches && target.matches('[name="id"]')) {
            const parentForm = target.closest('form');
            if (parentForm && parentForm.action && parentForm.action.indexOf('/cart/add') !== -1) {
              this._syncVariantId(target.value);
            }
          }
          if (target.matches && target.matches('input[type="radio"][name^="options["], select[name^="options["], fieldset[name^="options["] input')) {
            setTimeout(() => {
              const mainForm = document.querySelector('form[action*="/cart/add"]:not([data-pm-sticky-form])');
              const mainIdInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
              const mainId = mainIdInput ? mainIdInput.value : null;
              if (mainId) this._syncVariantId(mainId);
            }, 80);
          }
        });
        document.addEventListener('variant:change', (e) => {
          const variant = e.detail && e.detail.variant;
          if (variant && variant.id) {
            this._applyVariant(variant);
          }
        });
      }
      _bindDawnPubSub() {
        if (typeof window.subscribe !== 'function' || typeof window.PUB_SUB_EVENTS === 'undefined') return;
        try {
          if (window.PUB_SUB_EVENTS.variantChange) {
            const unsub = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event && event.data && (event.data.variant || (event.data.html && event.data.variant));
              if (variant && variant.id) {
                this._applyVariant(variant);
              } else if (event && event.data && event.data.sectionId) {
                const mainForm = document.querySelector('form[action*="/cart/add"]:not([data-pm-sticky-form])');
                const mainIdInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
                if (mainIdInput && mainIdInput.value) this._syncVariantId(mainIdInput.value);
              }
            });
            if (typeof unsub === 'function') this._dawnUnsub.push(unsub);
          }
        } catch (err) {
          console.warn('[sticky-atc] dawn pub/sub variant subscribe failed', err);
        }
      }
      async _syncVariantId(variantId) {
        if (!variantId || String(variantId) === String(this.idInput.value)) return;
        this.idInput.value = variantId;
        if (!this._productData) {
          try {
            const res = await fetch(`/products/${this.productHandle}.js`);
            this._productData = await res.json();
          } catch (err) {
            console.error('[sticky-atc] variant fetch', err);
            return;
          }
        }
        const variants = this._productData && this._productData.variants;
        const variant = variants && variants.find(v => String(v.id) === String(variantId));
        if (variant) this._applyVariant(variant);
      }
      _applyVariant(variant) {
        if (!variant) return;
        this.idInput.value = variant.id;
        if (this.priceEl && typeof variant.price === 'number') {
          this.priceEl.textContent = this._formatMoney(variant.price);
        }
        if (this.variantEl && variant.title && variant.title !== 'Default Title') {
          this.variantEl.textContent = variant.title;
        }
        if (this.imageEl && variant.featured_image && variant.featured_image.src) {
          this.imageEl.src = variant.featured_image.src;
        }
        if (variant.available === false) {
          this._renderSoldOut();
        } else if (this.btn && this.btn.classList.contains('pm-sticky__btn--soldout')) {
          window.location.reload();
        }
      }
      _renderSoldOut() {
        if (!this.btn || this.btn.classList.contains('pm-sticky__btn--soldout')) return;
        this.btn.classList.add('pm-sticky__btn--soldout');
        this.btn.type = 'button';
        const label = this.btn.querySelector('.pm-sticky__btn-label');
        if (label) label.textContent = 'Уведоми ме';
      }
      _formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          try { return window.Shopify.formatMoney(cents, this.moneyFormat); } catch (_) {}
        }
        const value = (cents / 100).toFixed(2).replace(/\.00$/, '');
        const fmt = this.moneyFormat || ('{' + '{amount}' + '}');
        return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, value);
      }
      _bindSubmit() {
        if (!this.form) return;
        this.form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const variantId = this.idInput && this.idInput.value;
          if (!variantId || variantId === '') {
            this._scrollToVariantPicker();
            return;
          }
          await this._addToCart(variantId);
        });
      }
      _scrollToVariantPicker() {
        const picker = document.querySelector('variant-radios, variant-selects, .product-form__input');
        if (picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this._announce('Избери опция за продукта');
          picker.style.transition = 'outline 0.4s ease';
          picker.style.outline = '2px solid #B8924A';
          picker.style.outlineOffset = '4px';
          setTimeout(() => {
            picker.style.outline = '';
            picker.style.outlineOffset = '';
          }, 1600);
        }
      }
      async _addToCart(variantId) {
        if (!this.btn) return;
        this.btn.setAttribute('data-state', 'loading');
        try {
          const formData = new FormData(this.form);
          if (window.routes && window.routes.cart_add_url) {
            // ok
          }
          formData.append('sections_url', window.location.pathname);
          const res = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Add to cart failed');
          }
          const data = await res.json().catch(() => null);
          this.btn.setAttribute('data-state', 'success');
          this._announce('Артикулът е добавен в кошницата');
          document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc', productVariantId: variantId, cartData: data }); } catch (_) {}
          }
          setTimeout(() => {
            this.btn.removeAttribute('data-state');
          }, 1600);
        } catch (err) {
          console.error('[sticky-atc] add', err);
          this.btn.removeAttribute('data-state');
          this._announce('Възникна грешка. Опитай отново.');
        }
      }
      _bindSoldOut() {
        const soldOutBtn = this.querySelector('[data-pm-sticky-soldout]');
        if (!soldOutBtn) return;
        soldOutBtn.addEventListener('click', () => {
          const bisForm = document.querySelector(
            '[data-pm-bis], .klaviyo-bis-trigger, [data-klaviyo-back-in-stock]'
          );
          if (bisForm) {
            bisForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (typeof bisForm.click === 'function') bisForm.click();
          } else {
            const fallback = document.querySelector(this.triggerSelector);
            if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this._announce('Скоро отново в наличност');
          }
        });
      }
      _announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => { this.live.textContent = msg; }, 50);
      }
    }
    customElements.define('sticky-atc', StickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-v4-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-v4-cart-drawer')) {
    class PmV4CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.openTrigger = null;
        this.focusableSelector =
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]';
        this._qtyTimers = new Map();
      }
      connectedCallback() {
        this._bindGlobalTriggers();
        this._bindEvents();
      }
      disconnectedCallback() {
        // Theme Editor пре-рендира секцията при всяка промяна. Без това старите
        // document listener-и оцеляват detached и техният stopImmediatePropagation
        // изяжда клика преди живата инстанция да го види → количката спира да се отваря.
        (this._globalUnbind || []).forEach(function (off) { off(); });
        this._globalUnbind = null;
        if (this._nativeObserver) {
          this._nativeObserver.disconnect();
          this._nativeObserver = null;
        }
      }
      _bindGlobalTriggers() {
        if (this._globalUnbind) return;
        this._globalUnbind = [];
        const on = (target, type, fn, opts) => {
          target.addEventListener(type, fn, opts);
          this._globalUnbind.push(() => target.removeEventListener(type, fn, opts));
        };
        const handler = (e) => {
          const trigger = e.target.closest(
            '[data-pm-cart-open],' +
              'a[href="/cart"],a[href$="/cart"],a[href*="/cart?"],' +
              '[aria-controls*="cart-drawer"],[aria-controls="CartDrawer"],' +
              '[data-cart-toggle],[data-action*="cart"],' +
              'cart-icon,cart-icon-bubble,#cart-icon-bubble,[data-testid="cart-icon"],' +
              '.header-actions__cart-icon,.header__cart,.header__icon--cart,.cart-link,' +
              'header-drawer [aria-controls*="cart"],summary[aria-controls*="cart"]'
          );
          if (!trigger) return;
          if (trigger.hasAttribute('data-pm-cart-bypass')) return;
          if (this.contains(trigger)) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          this.openTrigger = trigger;
          this.refreshAndOpen();
        };
        on(document, 'click', handler, true);
        on(document, 'cart:added', () => this.refreshAndOpen());
        on(document, 'cart:updated', (e) => {
          // Собственото ни събитие вече е обработено (refresh() тече преди
          // _afterMutation) — иначе всяка промяна прави втори излишен fetch.
          if (e && e.detail && e.detail.source === 'pmv4-cart-drawer') return;
          this.refresh();
        });
        on(document, 'cart-update', () => this.refresh());
        on(document, 'cart:refresh', () => this.refresh());
        if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          try {
            window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshAndOpen());
          } catch (_) {}
        }
        this._suppressNativeDrawer();
      }
      _suppressNativeDrawer() {
        const closeIt = () => {
          document.querySelectorAll('cart-drawer.active, cart-drawer[open]').forEach((d) => {
            d.classList.remove('active');
            d.removeAttribute('open');
            d.setAttribute('aria-hidden', 'true');
          });
        };
        closeIt();
        if (this._nativeObserver) return;
        const target = document.querySelector('cart-drawer');
        if (!target) return;
        this._nativeObserver = new MutationObserver(closeIt);
        this._nativeObserver.observe(target, {
          attributes: true,
          attributeFilter: ['open', 'class', 'aria-hidden'],
          subtree: true
        });
      }
      _bindEvents() {
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-pmv4-cd-close]')) this.close();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen()) this.close();
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pmv4-cd-qty]');
          if (!btn) return;
          const key = btn.getAttribute('data-key');
          const input = this.querySelector(`[data-pmv4-cd-qty-input][data-key="${key}"]`);
          if (!input) return;
          let qty = parseInt(input.value, 10) || 1;
          qty = btn.getAttribute('data-pmv4-cd-qty') === 'increase' ? qty + 1 : Math.max(1, qty - 1);
          input.value = qty;
          this._scheduleQtyUpdate(key, qty);
        });
        this.addEventListener('input', (e) => {
          const input = e.target.closest('[data-pmv4-cd-qty-input]');
          if (!input) return;
          let qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 1) qty = 1;
          this._scheduleQtyUpdate(input.getAttribute('data-key'), qty);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pmv4-cd-remove]');
          if (!btn) return;
          this._removeItem(btn.getAttribute('data-key'));
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-pmv4-cd-add]');
          if (!btn) return;
          this._addUpsell(btn.getAttribute('data-pmv4-cd-add'), btn);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key !== 'Tab' || !this.isOpen()) return;
          const focusables = this._getFocusables();
          if (focusables.length === 0) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
      }
      _getFocusables() {
        const panel = this.querySelector('.pmv4-cd-panel');
        if (!panel) return [];
        return Array.from(panel.querySelectorAll(this.focusableSelector)).filter(
          (el) => !el.hasAttribute('hidden') && el.offsetParent !== null
        );
      }
      isOpen() {
        return this.getAttribute('data-open') === 'true';
      }
      open() {
        if (this.isOpen()) return;
        this.setAttribute('data-open', 'true');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        setTimeout(() => {
          const panel = this.querySelector('.pmv4-cd-panel');
          if (panel) panel.focus();
        }, 50);
      }
      close() {
        if (!this.isOpen()) return;
        this.setAttribute('data-open', 'false');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.touchAction = '';
        if (this.openTrigger && typeof this.openTrigger.focus === 'function') {
          this.openTrigger.focus();
        }
        this.openTrigger = null;
      }
      async refresh() {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}?section_id=${this.dataset.sectionId}`);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const newDrawer = doc.querySelector(`#${this.id}`);
          if (newDrawer) {
            const newPanel = newDrawer.querySelector('.pmv4-cd-panel');
            const oldPanel = this.querySelector('.pmv4-cd-panel');
            if (newPanel && oldPanel) oldPanel.innerHTML = newPanel.innerHTML;
          }
        } catch (err) {
          console.error('[pmv4-cart-drawer] refresh failed', err);
        }
      }
      async refreshAndOpen() {
        await this.refresh();
        this.open();
      }
      async _refreshCartIcon() {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}?section_id=cart-icon-bubble`);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('.shopify-section');
          const target = document.getElementById('cart-icon-bubble');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        } catch (_) {}
      }
      _scheduleQtyUpdate(key, qty) {
        if (this._qtyTimers.has(key)) clearTimeout(this._qtyTimers.get(key));
        this._qtyTimers.set(key, setTimeout(() => this._updateQty(key, qty), 350));
      }
      async _updateQty(key, quantity) {
        this._setLoading(true);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity })
          });
          if (!res.ok) throw new Error('Quantity update failed');
          await this.refresh();
          this._announce(this.getAttribute('data-msg-updated') || 'Количката е обновена');
          this._afterMutation();
        } catch (err) {
          console.error('[pmv4-cart-drawer] qty update', err);
          this._announce(this.getAttribute('data-msg-error') || 'Възникна грешка');
        } finally {
          this._setLoading(false);
        }
      }
      async _removeItem(key) {
        const item = this.querySelector(`[data-pmv4-cd-item][data-key="${key}"]`);
        if (item) item.classList.add('is-removing');
        this._setLoading(true);
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          if (!res.ok) throw new Error('Remove failed');
          await this.refresh();
          this._announce(this.getAttribute('data-msg-removed') || 'Продуктът е премахнат');
          this._afterMutation();
        } catch (err) {
          console.error('[pmv4-cart-drawer] remove', err);
          if (item) item.classList.remove('is-removing');
          this._announce(this.getAttribute('data-msg-error') || 'Възникна грешка');
        } finally {
          this._setLoading(false);
        }
      }
      async _addUpsell(variantId, btn) {
        // Без disabled бърз двоен клик пращаше два /cart/add.js → 2 бройки.
        if (btn && btn.hasAttribute('data-loading')) return;
        if (btn) {
          btn.setAttribute('data-loading', 'true');
          btn.disabled = true;
        }
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('Add failed');
          await this.refresh();
          this._announce(this.getAttribute('data-msg-added') || 'Добавено в количката');
          this._afterMutation();
        } catch (err) {
          console.error('[pmv4-cart-drawer] add upsell', err);
          this._announce(this.getAttribute('data-msg-error') || 'Възникна грешка');
        } finally {
          if (btn) {
            btn.removeAttribute('data-loading');
            btn.disabled = false;
          }
        }
      }
      _afterMutation() {
        this._refreshCartIcon();
        // Хедърът слуша 'cart:updated' — това е контрактът. Собственото
        // 'pmv4:cart:updated' се пази за съвместимост, но само то оставяше
        // брояча в хедъра застинал след промяна на количество/премахване.
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pmv4-cart-drawer' } }));
        document.dispatchEvent(new CustomEvent('pmv4:cart:updated'));
      }
      _setLoading(state) {
        this.classList.toggle('is-loading', state);
      }
      _announce(msg) {
        const live = this.querySelector('[data-pmv4-cd-live]');
        if (!live) return;
        live.textContent = '';
        setTimeout(() => {
          live.textContent = msg;
        }, 50);
      }
    }
    customElements.define('pm-v4-cart-drawer', PmV4CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-v4-collection-head"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSortSelects(root) {
      (root || document).querySelectorAll('[data-pmv4-ch-sort]').forEach(function (select) {
        if (select.dataset.pmv4Bound) return;
        select.dataset.pmv4Bound = 'true';
        select.addEventListener(
          'change',
          function () {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', select.value);
            url.searchParams.delete('page');
            window.location.assign(url.toString());
          },
          { passive: true }
        );
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSortSelects(document); }, { passive: true });
    } else {
      initSortSelects(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initSortSelects(e.target); }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-v4-main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMainCart(root) {
      (root || document).querySelectorAll('[data-pmv4-mc]').forEach(function (section) {
        if (section.dataset.pmv4Bound) return;
        section.dataset.pmv4Bound = 'true';

        var timers = {};

        function announce(msg) {
          var live = section.querySelector('[data-pmv4-mc-live]');
          if (!live) return;
          live.textContent = '';
          setTimeout(function () { live.textContent = msg; }, 50);
        }

        function change(key, quantity) {
          section.classList.add('is-loading');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('change failed');
              // без презареждане: Shopify връща само тази секция наново и я подменяме на място
              var wrap = section.closest('[id^="shopify-section-"]');
              var sid = wrap ? wrap.id.replace('shopify-section-', '') : '';
              if (!sid) { window.location.reload(); return; }
              return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
                .then(function (r) {
                  if (!r.ok) throw new Error('render failed');
                  return r.text();
                })
                .then(function (html) {
                  var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pmv4-mc]');
                  if (!fresh) { window.location.reload(); return; }
                  section.replaceWith(fresh);
                  initMainCart(wrap);
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                });
            })
            .catch(function (err) {
              console.error('[pmv4-main-cart]', err);
              section.classList.remove('is-loading');
              var row = section.querySelector('[data-pmv4-mc-item][data-key="' + key + '"]');
              if (row) row.classList.remove('is-removing');
              announce(section.getAttribute('data-msg-error') || 'Възникна грешка. Опитай отново.');
            });
        }

        function schedule(key, qty) {
          clearTimeout(timers[key]);
          timers[key] = setTimeout(function () { change(key, qty); }, 350);
        }

        section.addEventListener('click', function (e) {
          var qtyBtn = e.target.closest('[data-pmv4-mc-qty]');
          if (qtyBtn) {
            var key = qtyBtn.getAttribute('data-key');
            var input = section.querySelector('[data-pmv4-mc-qty-input][data-key="' + key + '"]');
            if (!input) return;
            var qty = parseInt(input.value, 10) || 1;
            qty = qtyBtn.getAttribute('data-pmv4-mc-qty') === 'increase' ? qty + 1 : Math.max(1, qty - 1);
            input.value = qty;
            schedule(key, qty);
            return;
          }
          var rmBtn = e.target.closest('[data-pmv4-mc-remove]');
          if (rmBtn) {
            var rmKey = rmBtn.getAttribute('data-key');
            var row = section.querySelector('[data-pmv4-mc-item][data-key="' + rmKey + '"]');
            if (row) row.classList.add('is-removing');
            change(rmKey, 0);
          }
        });

        section.addEventListener('change', function (e) {
          var input = e.target.closest('[data-pmv4-mc-qty-input]');
          if (input) {
            var qty = parseInt(input.value, 10);
            if (isNaN(qty) || qty < 1) qty = 1;
            input.value = qty;
            schedule(input.getAttribute('data-key'), qty);
            return;
          }
          var note = e.target.closest('[data-pmv4-mc-note]');
          if (note) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: note.value })
            }).catch(function (err) {
              console.error('[pmv4-main-cart] note', err);
            });
          }
        });

        section.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          var input = e.target.closest('[data-pmv4-mc-qty-input]');
          if (!input) return;
          e.preventDefault();
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 1) qty = 1;
          input.value = qty;
          schedule(input.getAttribute('data-key'), qty);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initMainCart(document); }, { passive: true });
    } else {
      initMainCart(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initMainCart(e.target); }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-v4-sos-chapter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.pmv4RevealInit) return;
    window.pmv4RevealInit = true;
    function observeAll() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.pmv4-reveal').forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );
      document.querySelectorAll('.pmv4-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
      document.addEventListener('shopify:section:load', function () {
        document.querySelectorAll('.pmv4-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
      }, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll, { passive: true });
    } else {
      observeAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-v4-sos-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSos(root) {
      (root || document).querySelectorAll('[data-pmv4-sos]').forEach(function (sos) {
        if (sos.dataset.pmv4Bound) return;
        sos.dataset.pmv4Bound = 'true';
        var tabs = sos.querySelectorAll('[data-pmv4-sos-tab]');
        var imgs = sos.querySelectorAll('.pmv4-sos-bg img, .pmv4-sos-disc img');
        var nameEl = sos.querySelector('[data-pmv4-sos-name]');
        var discLink = sos.querySelector('[data-pmv4-sos-disclink]');
        var spotifyBtn = sos.querySelector('[data-pmv4-sos-spotify]');
        var pdpLink = sos.querySelector('[data-pmv4-sos-pdp]');
        tabs.forEach(function (tab) {
          tab.addEventListener(
            'click',
            function () {
              var k = tab.dataset.k;
              tabs.forEach(function (t) {
                t.classList.toggle('on', t === tab);
                t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
              });
              imgs.forEach(function (img) {
                img.classList.toggle('on', img.dataset.k === k);
              });
              if (nameEl) nameEl.textContent = tab.dataset.name || '';
              if (discLink && tab.dataset.playlist) discLink.href = tab.dataset.playlist;
              if (spotifyBtn && tab.dataset.playlist) spotifyBtn.href = tab.dataset.playlist;
              if (pdpLink && tab.dataset.pdp) pdpLink.href = tab.dataset.pdp;
            },
            { passive: true }
          );
        });
      });
    }
    function initReveal() {
      if (window.pmv4RevealInit) return;
      window.pmv4RevealInit = true;
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.pmv4-reveal').forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );
      document.querySelectorAll('.pmv4-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
      document.addEventListener('shopify:section:load', function () {
        document.querySelectorAll('.pmv4-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
      }, { passive: true });
    }
    function boot() {
      initSos(document);
      initReveal();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { passive: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { initSos(e.target); }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
